export const SIDEBAR_WIDTH = 480;
export const MAP_STYLES = {
    STANDARD: "standard",
    SATELLITE: "standard-satellite",
    THREE_DIMENSIONAL: "three-dimensional",
};
export const TRANSPORTATION_MODES = ["car", "transit", "walk", "bike"];
